import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { Condition } from 'Component/others';
import { getMenuPermissions } from 'Helper/getMenuPermissions';

import Presence from 'View/monitoring/section/presence';
import Head from 'View/monitoring/section/head';
import styles from 'View/monitoring/styles.module.css';
import DailyLog from 'View/monitoring/section/daily-log';
import ActiveOperators from 'View/monitoring/section/active-operators';
import useGetMonitoringStatus from 'Domain/monitoring/useGetMonitoringStatus';
import Clockin from 'View/monitoring/section/clock-in';
import useMonitoringState from 'View/monitoring/state';

const Monitoring = () => {
  const monitoringPermissions = getMenuPermissions('main-dashboard', 'monitoring-operator');
  const isCanMonitoring = monitoringPermissions?.isCanRead;
  const { t } = useTranslation('dashboard');

  const { data: monitoringStatus, isFetching } = useGetMonitoringStatus({ isEnabled: isCanMonitoring });
  const { selectedView } = useMonitoringState();

  const isPresence = selectedView?.includes('presence');
  const isClockIn = selectedView?.includes('clock-in');
  const isBreak = selectedView?.includes('break');
  const isShowLogAndActiveOperator = !isPresence;

  return (
    <Condition statement={isCanMonitoring}>
      <Box className={styles['monitoring__container']}>
        <Head isFetching={isFetching} t={t} />
        <Condition statement={isPresence} children={<Presence isFetching={isFetching} t={t} />} />
        <Condition statement={isClockIn || isBreak} children={<Clockin monitoringStatus={monitoringStatus} isFetching={isFetching} t={t} />} />
        <Condition statement={isShowLogAndActiveOperator}>
          <Box className={styles['monitoring__table--wrapper']}>
            <DailyLog monitoringStatus={monitoringStatus} t={t} />
            <ActiveOperators t={t} />
          </Box>
        </Condition>
      </Box>
    </Condition>
  );
};

export default Monitoring;
